var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
import { SmsOtp } from '@pcln/account-less-auth-sdk';
import { otpDeliveryMechanisms } from '../constants';
const otpService = ({
  deliveryType
}) => {
  const url = 'account-less-auth';
  const accountLessSdk = deliveryType === otpDeliveryMechanisms.SMS ? new SmsOtp(url) : null;
  if (!accountLessSdk) {
    throw new Error('AccountLess Sdk needs to be initialized');
  }
  let verifyFn = null;
  return {
    createChallenge: ({
      scope,
      requestFrom,
      countryCode,
      phoneNumber,
      email,
      requestHeaders
    }) => __awaiter(void 0, void 0, void 0, function* () {
      try {
        verifyFn = null;
        const challenge = yield accountLessSdk.withScope(scope).withRequestFrom(requestFrom).withPhoneNumber(countryCode, phoneNumber).withEmail(email).build().createChallenge({
          headers: requestHeaders
        });
        if (challenge.success) {
          verifyFn = challenge.verify;
          return challenge.success;
        } else {
          throw new Error('Unable to create a challenge');
        }
      } catch (_e) {
        throw new Error('Account less sdk api error');
      }
    }),
    verify: otpCode => __awaiter(void 0, void 0, void 0, function* () {
      if (!verifyFn) {
        throw new Error('Verification function is required');
      } else {
        try {
          const verifyResult = yield verifyFn(otpCode);
          return {
            success: verifyResult.success,
            token: verifyResult.success ? verifyResult.token : ''
          };
        } catch (_e) {
          throw new Error('Otp verificaton api failed');
        }
      }
    })
  };
};
export default otpService;